// Decides whether the section card should render its header row. The header is
// only meaningful when at least one of title/order/actions is provided, so the
// component can stay dumb and skip the header markup entirely otherwise.
const useLifecareStudioSectionCard = ({ title, order, actions }) => {
  const hasHeader = Boolean(title || order || actions);
  return { hasHeader };
};

export default useLifecareStudioSectionCard;
